import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useQuery, useQueryClient, UseQueryOptions } from 'react-query'
import { BrandVisualKit } from 'types'
import { sendToApi } from 'api/client'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'

interface Data {
  brand_visual_kit: BrandVisualKit
}

interface Props {
  id: number
}

type CacheData = { brand_visual_kits: BrandVisualKit[] } | undefined

export const fetchBrandVisualKit = (id: number, workspaceId: number) =>
  sendToApi<Data>(`/w/${workspaceId}/brand_visual_kits/${id}`)

export const useBrandVisualKit = ({ id }: Props, options?: UseQueryOptions<Data>) => {
  const currentWorkspaceId = useCurrentWorkspaceId()
  const queryClient = useQueryClient()

  return useQuery<Data>(
    ['workspaces', currentWorkspaceId, 'brand_visual_kits', id],
    async () => {
      const res = await fetchBrandVisualKit(id, currentWorkspaceId)
      if (res.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error()
      }
      return res.data
    },
    {
      initialData: () => {
        const existingBrandVisualKit = queryClient
          .getQueryData<CacheData>(['workspaces', currentWorkspaceId, 'brand_visual_kits', 'list'])
          ?.brand_visual_kits.find((brandVisualKit) => brandVisualKit.id === id)

        if (!existingBrandVisualKit) return

        return {
          brand_visual_kit: existingBrandVisualKit,
        }
      },
      refetchOnWindowFocus: false,
      ...options,
    },
  )
}
